<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
    persistent
    content-class="my-custom-dialog"
    style="border-radius: 20px !important">
    <v-card>
      <v-card-title style="background-color: #1577da; font-weight: bold; color: white">
        <span class="text-h5" style="font-weight: bold">
          {{ documentType === 'outgoing' ? 'eIzvještavanje' : 'Ažuriranje statusa dokumenta' }}
        </span>
      </v-card-title>

      <v-form ref="form" v-model="valid" @submit.prevent="updateStatus">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="selectedStatus"
                  :items="availableStatuses"
                  item-text="text"
                  item-value="value"
                  label="Novi status"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-col>

              <v-col cols="12" v-if="selectedStatus === 8">
                <v-text-field
                  v-model="partialPaymentAmount"
                  label="Iznos djelomične uplate"
                  type="number"
                  step="0.01"
                  min="0"
                  :rules="[rules.required, rules.positiveNumber]"
                  suffix="EUR"
                ></v-text-field>
              </v-col>

              <!-- Payment fields - only for outgoing status 5 (Označi kao naplaćen) -->
              <v-col cols="12" v-if="selectedStatus === 5 && documentType === 'outgoing'">
                <v-text-field
                  v-model="paidAmount"
                  label="Plaćeni iznos"
                  type="number"
                  step="0.01"
                  min="0"
                  :rules="[rules.required, rules.positiveNumber]"
                  suffix="EUR"
                ></v-text-field>
              </v-col>

              <v-col cols="12" v-if="selectedStatus === 5 && documentType === 'outgoing'">
                <v-text-field
                  v-model="paymentDate"
                  label="Datum plaćanja"
                  type="date"
                  :max="new Date().toISOString().substr(0, 10)"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" v-if="selectedStatus === 5 && documentType === 'outgoing'">
                <v-select
                  v-model="paymentType"
                  :items="paymentTypeOptions"
                  item-text="text"
                  item-value="value"
                  label="Tip plaćanja"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-col>

              <!-- Rejection fields - only for incoming invoices -->
              <v-col cols="12" v-if="selectedStatus === 6 && documentType === 'incoming'">
                <v-text-field
                  v-model="rejectionDate"
                  label="Datum odbijanja"
                  type="date"
                  :max="new Date().toISOString().substr(0, 10)"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" v-if="selectedStatus === 6 && documentType === 'incoming'">
                <v-select
                  v-model="rejectionType"
                  :items="rejectionTypeOptions"
                  item-text="text"
                  item-value="value"
                  label="Tip odbijanja"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="note"
                  :label="selectedStatus === 6 ? 'Razlog odbijanja (obavezno)' : 'Napomene (neobavezno)'"
                  rows="3"
                  auto-grow
                  counter="500"
                  :rules="selectedStatus === 6 ? [rules.required, rules.maxLength] : [rules.maxLength]"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="pr-10 pl-10">
          <v-row dense style="margin-top: 1rem; margin-bottom: 1rem">
            <v-spacer></v-spacer>
            <v-btn class="btn infoButton" style="margin-right: 1rem" @click="dialog = false" :disabled="loading">
              Odustani
            </v-btn>
            <v-btn
              class="btn successButton"
              type="submit"
              :loading="loading"
              :disabled="!valid"
            >
              Ažuriraj
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'StatusUpdateDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    documentId: {
      type: [String, Number],
      default: null
    },
    issueYear: {
      type: Number,
      default: null
    },
    currentStatus: {
      type: Number,
      default: null
    },
    documentType: {
      type: String,
      default: 'incoming' // 'incoming' ili 'outgoing'
    },
    documentAmount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      valid: false,
      loading: false,
      selectedStatus: null,
      partialPaymentAmount: null,
      paidAmount: null,
      paymentType: 1,
      paymentDate: new Date().toISOString().substr(0, 10),
      rejectionType: 1,
      rejectionDate: new Date().toISOString().substr(0, 10),
      note: '',
      incomingStatusOptions: [
        { value: 1, text: 'Na čekanju' },
        { value: 2, text: 'Na slanju' },
        { value: 3, text: 'Poslan' },
        { value: 4, text: 'Isporučen' },
        { value: 5, text: 'Prihvaćen' },
        { value: 6, text: 'Odbijen' },
        { value: 7, text: 'Plaćen u potpunosti' },
        { value: 8, text: 'Parcijalno plaćen' },
        { value: 9, text: 'Neuspješna isporuka' }
      ],
      outgoingStatusOptions: [
        { value: 1, text: 'Na čekanju' },
        { value: 2, text: 'Na slanju' },
        { value: 3, text: 'Poslan' },
        { value: 4, text: 'Isporučen' },
        { value: 5, text: 'Označi kao naplaćen' },
        { value: 6, text: 'Označi kao odbijen' },
        { value: 7, text: 'Plaćen u potpunosti' },
        { value: 8, text: 'Parcijalno plaćen' },
        { value: 9, text: 'Neuspješna isporuka' }
      ],
      paymentTypeOptions: [
        { value: 1, text: 'Transakcijski račun (T)' },
        { value: 2, text: 'Obračunsko plaćanje (O)' },
        { value: 3, text: 'Ostalo (Z)' }
      ],
      rejectionTypeOptions: [
        { value: 1, text: 'Neusklađenost podataka koji ne utječu na obračun poreza (N)' },
        { value: 2, text: 'Neusklađenost podataka koji utječu na obračun poreza (U)' },
        { value: 3, text: 'Ostalo (O)' }
      ],
      rules: {
        required: value => !!value || 'Ovo polje je obavezno',
        positiveNumber: value => (value > 0) || 'Iznos mora biti veći od 0',
        maxLength: value => !value || value.length <= 500 || 'Maksimalno 500 znakova'
      }
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    availableStatuses () {
      const statusOptions = this.documentType === 'incoming' ? this.incomingStatusOptions : this.outgoingStatusOptions

      if (this.documentType === 'incoming') {
        // Za ulazne račune: različite opcije ovisno o trenutnom statusu
        if (this.currentStatus === 3) {
          // Iz statusa 3 (Poslan) može ići u status 5 (Prihvaćen) ili 6 (Odbijen)
          return statusOptions.filter(status => {
            return status.value === 5 || status.value === 6
          })
        } else if (this.currentStatus === 4) {
          // Iz statusa 4 (Isporučen) može ići u status 5 (Prihvaćen) ili 6 (Odbijen)
          return statusOptions.filter(status => {
            return status.value === 5 || status.value === 6
          })
        } else if (this.currentStatus === 5) {
          // Iz statusa 5 (Prihvaćen) može ići u status 7 (Plaćen u potpunosti) ili 8 (Parcijalno plaćen)
          return statusOptions.filter(status => {
            return status.value === 7 || status.value === 8
          })
        }
        return []
      } else {
        // Za izlazne račune: omogući samo označavanje kao plaćen (status 5)
        return statusOptions.filter(status => {
          return status.value === 5
        })
      }
    }
  },
  watch: {
    value (newVal) {
      if (newVal) {
        this.selectedStatus = this.currentStatus
        this.partialPaymentAmount = null
        this.paidAmount = this.documentAmount || 0
        this.paymentType = 1
        this.paymentDate = new Date().toISOString().substr(0, 10)
        this.rejectionType = 1
        this.rejectionDate = new Date().toISOString().substr(0, 10)
        this.note = ''
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.resetValidation()
          }
        })
      }
    }
  },
  methods: {
    async updateStatus () {
      if (!this.$refs.form.validate()) {
        return
      }

      if (!this.documentId) {
        this.$emit('error', 'ID dokumenta nije definisan')
        return
      }

      this.loading = true
      try {
        const payload = {
          status: this.selectedStatus,
          note: this.note || null
        }

        const updateMask = ['status']

        if (this.note && this.note.trim()) {
          updateMask.push('note')
        }

        if (this.selectedStatus === 8 && this.partialPaymentAmount) {
          payload.partialPaymentAmount = parseFloat(this.partialPaymentAmount)
          updateMask.push('partialPaymentAmount')
        }

        // Payment data - only for outgoing status 5
        if (this.selectedStatus === 5 && this.documentType === 'outgoing' && this.paidAmount) {
          payload.paidAmount = parseFloat(this.paidAmount)
          payload.paymentType = this.paymentType
          payload.paymentDate = this.paymentDate
        }

        // Rejection data - only for incoming invoices
        if (this.selectedStatus === 6 && this.documentType === 'incoming') {
          payload.rejectionReason = this.note || 'Dokument je odbačen'
          payload.rejectionType = this.rejectionType
          payload.rejectionDate = this.rejectionDate
        }

        this.$emit('update-status', {
          documentId: this.documentId,
          issueYear: this.issueYear,
          payload,
          updateMask
        })

        this.dialog = false
      } catch (error) {
        console.error('Error updating status:', error)
        this.$emit('error', 'Greška pri ažuriranju statusa dokumenta')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.v-dialog__content >>> .my-custom-dialog {
  position: absolute;
  top: 30px;
  border-radius: 25px !important;
}
</style>
